import { TrialResultQuery } from "@generated/graphql";
import { KnowledgeBlocks } from "pages/Testing/view/Personal/types";
import { getSkillScore, getSkillTime } from ".";

type TrialAnswer = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<TrialResultQuery["trial"]>["examination"]["competencyMap"]["competences"]
        >[number]["knowledgeBlockCompetences"]
      >[number]["knowledgeBlock"]["skills"]
    >[number]["trialAnswers"]
  >[number]
>;

type TrialAnswerQuestion = TrialAnswer["question"];

export type CandidateAnswerData = Pick<TrialAnswer, "partsIds" | "file"> & {
  questionText: TrialAnswerQuestion["text"];
  candidateAnswer: TrialAnswer["answer"];
  questionType?: TrialAnswerQuestion["type"];
  questionParts?: TrialAnswerQuestion["parts"];
};

export type ExpandedTrialAnswer = Pick<TrialAnswer, "id" | "score" | "time" | "criterionAssessments"> &
  CandidateAnswerData & {
    blockTitle: string;
    knowledgeBlockTitle: string;
    skillTitle: string;
    candidateAnswer: TrialAnswer["answer"];
    additionalAnswers?: CandidateAnswerData[];
  };

const getCandidateAnswerData = (answer: TrialAnswer, additionalAnswers: boolean = false): CandidateAnswerData => ({
  file: answer.file,
  questionText: additionalAnswers ? answer.additionalQuestion || "" : answer.question.text,
  questionType: answer.question.type,
  questionParts: answer.question.parts?.map(({ id, content, isCorrect }) => ({
    id,
    content,
    isCorrect,
  })),
  candidateAnswer: answer.answer,
  partsIds: answer.partsIds,
});

const getTrialAnswerList = (knowledgeBlocks: KnowledgeBlocks): Array<ExpandedTrialAnswer> => {
  const result: Array<ExpandedTrialAnswer> = [];

  if (!knowledgeBlocks) return result;

  knowledgeBlocks.forEach((block) => {
    const blockTitle = block.title;

    (block.knowledgeBlockCompetences || []).forEach((knowledgeBlockCompetence) => {
      const knowledgeBlockTitle = knowledgeBlockCompetence.knowledgeBlock.title;

      (knowledgeBlockCompetence.knowledgeBlock.skills || []).forEach((skill) => {
        const skillTitle = skill.title;
        const { trialAnswers } = skill;
        if (!trialAnswers?.length) return;

        const baseAnswer = trialAnswers[0];
        const additionalAnswers = trialAnswers.slice(1);

        result.push({
          blockTitle,
          knowledgeBlockTitle,
          skillTitle,
          id: baseAnswer.id,
          score: getSkillScore({ trialAnswers }),
          time: getSkillTime({ trialAnswers }),
          criterionAssessments: baseAnswer.criterionAssessments,
          ...getCandidateAnswerData(baseAnswer),
          additionalAnswers: additionalAnswers.map((additionalAnswer) =>
            getCandidateAnswerData(additionalAnswer, true)
          ),
        });
      });
    });
  });

  return result;
};

export default getTrialAnswerList;
